/* VIPet Store — click a toy in the catalogue to enlarge it.
   Scoped to the toy catalogue grid on purpose, so it can't surprise anyone
   on product or collection pages. Closes on backdrop, on the X, or on Esc. */
(function () {
  var overlay = null;
  var lastFocus = null;
  var hideTimer = null;

  function build() {
    overlay = document.createElement('div');
    overlay.className = 'vipet-lb';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.innerHTML =
      '<button class="vipet-lb__close" type="button" aria-label="סגירה">✕</button>' +
      '<img alt="">';
    document.body.appendChild(overlay);

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay || e.target.closest('.vipet-lb__close')) close();
    });
  }

  function open(src, alt, trigger) {
    if (!overlay) build();
    clearTimeout(hideTimer);
    lastFocus = trigger || null;

    var img = overlay.querySelector('img');
    img.src = src;
    img.alt = alt || '';

    overlay.style.display = 'grid';
    window.requestAnimationFrame(function () { overlay.setAttribute('data-open', ''); });

    document.documentElement.style.overflow = 'hidden';
    document.addEventListener('keydown', onKey);
    overlay.querySelector('.vipet-lb__close').focus();
  }

  function close() {
    if (!overlay) return;
    overlay.removeAttribute('data-open');
    document.documentElement.style.overflow = '';
    document.removeEventListener('keydown', onKey);

    hideTimer = setTimeout(function () {
      overlay.style.display = 'none';
      overlay.querySelector('img').removeAttribute('src');
    }, 220);

    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function onKey(e) {
    if (e.key === 'Escape' || e.key === 'Esc') close();
  }

  document.addEventListener('click', function (e) {
    var img = e.target.closest('.toycat .tc img');
    if (!img) return;
    e.preventDefault();
    open(img.currentSrc || img.src, img.alt, e.target.closest('.tc'));
  });
})();
